import styled from "styled-components";

export const FooterContent = styled.footer`
    background-color: #013330;
    padding: 4rem;
    text-align: center;
    clear: both;
    position: relative;
    margin-top: 16.7rem;



`

export const FooterLogo = styled.img`
    margin: 0 auto;
    width: 100%;
    max-width: 13rem;
`

export const SocialBox = styled.div``

export const SocialIcon = styled.img``

export const FooterCopy = styled.div`
    text-align: center;
    background-color: #8BB326;
    padding: 1rem;
`
export const CopyText = styled.p`
    color: #fff;
    font-size: 1rem;
`